import React from "react";
import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";
import { Phone } from "lucide-react";

export default function ImprintPage() {
    return (
        <PublicLayout>
            <Seo
                title="Impressum | Bewerbung24.ai"
                description="Impressum und Anbieterkennzeichnung der KI-Bewerbungsplattform Bewerbung24.ai mit Sitz in Hannover."
                path="/impressum"
            />
            <section className="max-w-3xl mx-auto px-6 lg:px-8 py-20" data-testid="imprint-page">
                <h1 className="font-heading text-4xl font-bold text-slate-900 mb-2">Impressum</h1>
                <p className="text-slate-500 mb-8">Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</p>

                <div className="space-y-6 text-slate-700">
                    <div>
                        <h2 className="font-heading text-xl font-semibold text-slate-900">Anbieter</h2>
                        <p>Bewerbung24.ai<br/>Am Kanal 22<br/>30599 Hannover<br/>Deutschland</p>
                    </div>
                    <div>
                        <h2 className="font-heading text-xl font-semibold text-slate-900">Zweigstelle</h2>
                        <p data-testid="imprint-branch">Bewerbung24.ai<br/>Im Mediapark 8<br/>50670 Köln<br/>Deutschland</p>
                    </div>
                    <div>
                        <h2 className="font-heading text-xl font-semibold text-slate-900">Vertretungsberechtigte</h2>
                        <p>Geschäftsführerin: Frau E. Decker</p>
                    </div>
                    <div className="rounded-2xl border-2 border-red-200 bg-red-50/60 p-5" data-testid="imprint-hotline">
                        <h2 className="font-heading text-xl font-semibold text-slate-900 inline-flex items-center gap-2"><Phone size={18} className="text-red-600" /> Soforthilfe</h2>
                        <p className="mt-1">
                            Telefon: <a href="tel:+491705721522" className="text-red-600 font-bold hover:underline">+49 170 5721522</a>
                        </p>
                    </div>
                    <div>
                        <h2 className="font-heading text-xl font-semibold text-slate-900">Kontakt</h2>
                        <p>
                            E-Mail: <a href="mailto:info@bewerbung24.ai" className="text-red-600 hover:underline">info@bewerbung24.ai</a><br/>
                            Web: <a href="https://www.bewerbung24.ai" target="_blank" rel="noreferrer" className="text-red-600 hover:underline">www.bewerbung24.ai</a><br/>
                            Telefon: +49 (0) 511 89862808<br/>
                            Fax: +49 (0) 511 89862810
                        </p>
                    </div>
                    <div>
                        <h2 className="font-heading text-xl font-semibold text-slate-900">Umsatzsteuer-Identifikationsnummer</h2>
                        <p>Umsatzsteuer-ID gemäß § 27 a Umsatzsteuergesetz: <strong>DE329443369</strong></p>
                    </div>
                    <div>
                        <h2 className="font-heading text-xl font-semibold text-slate-900">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
                        <p>Frau E. Decker<br/>Am Kanal 22<br/>30599 Hannover</p>
                    </div>
                    <div>
                        <h2 className="font-heading text-xl font-semibold text-slate-900">Streitschlichtung</h2>
                        <p>
                            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                            Verbraucherschlichtungsstelle teilzunehmen (§ 36 VSBG).
                        </p>
                    </div>
                </div>
            </section>
        </PublicLayout>
    );
}
